import { Check } from "lucide-react";
import { INTERACTION_MODES, type InteractionMode } from "@/lib/scenarios/interactionModes";
import { MODE_VISUALS } from "@/lib/scenarios/modeVisuals";
import { BetaBadge } from "@/components/ui/beta-badge";

const BETA_MODES = new Set<InteractionMode>(["role_play"]);

export function InteractionModePicker({
  value, onChange,
}: { value: InteractionMode; onChange: (v: InteractionMode) => void; }) {
  return (
    <div className="grid items-stretch gap-3.5 sm:grid-cols-3">
      {INTERACTION_MODES.map((m) => {
        const active = m.id === value;
        const beta = BETA_MODES.has(m.id);
        const v = MODE_VISUALS[m.id];
        const Icon = v.icon;
        return (
          <button
            key={m.id}
            type="button"
            onClick={() => onChange(m.id)}
            aria-pressed={active}
            style={{
              borderColor: active ? v.activeBorder : v.border,
              background: active ? v.activeBg : "#fff",
              borderWidth: 1.5,
              borderStyle: "solid",
            }}
            className="relative flex h-full flex-col text-left rounded-[14px] p-4 pb-[18px] transition-[border-color,background,box-shadow] hover:shadow-[0_2px_10px_rgba(12,12,12,0.08)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            {beta && (
              <BetaBadge className={active ? "absolute top-3 right-10" : "absolute top-3 right-3"} />
            )}
            {active && (
              <span
                className="absolute top-3 right-3 inline-flex h-[22px] w-[22px] items-center justify-center rounded-full text-white"
                style={{ background: v.check }}
              >
                <Check className="h-3.5 w-3.5" strokeWidth={3} />
              </span>
            )}
            <div
              className="mb-3 flex h-9 w-9 items-center justify-center rounded-[10px]"
              style={{ background: v.iconBg, color: v.iconFg }}
            >
              <Icon className="h-[19px] w-[19px]" />
            </div>
            <div
              className="text-base font-semibold leading-tight min-h-[20px]"
              style={{ color: v.iconFg }}
            >
              {m.label}
            </div>
            <p className="mt-1.5 flex-1 text-[13px] leading-relaxed text-muted-foreground">
              {m.description}
            </p>
          </button>
        );
      })}
    </div>
  );
}
